import React from 'react';
import { SatInput, SatRadio } from '@components/common/satUI';

import { NOTICE_MAX_LENGTH } from '@common/constants';

/**
 * 취미 영역
 */
const TableGroup = props => {
  const {
    isPreUw = false,
    group,
    items,
    tbNbsPolicyBfNtceAnsDtlDTO,
    tbNbsPolicyBfNtceAnsByitmDtlDTO,
    setTbNbsPolicyBfNtceAnsByitmDtlDTO,
    onSave,
  } = props;

  const title = items[0];
  const radio = items.slice(1, 3);
  const num = items[3];
  const text = items[4];

  const onChangeRadio = option => {
    const { value } = option;

    const prevItem = tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
      dtl =>
        dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo &&
        ($utils.isEmptyString(dtl.policyBfNtceItmNo) ||
          radio.find(itm => itm.policyBfNtceItmNo === dtl.policyBfNtceItmNo)),
    );

    let newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO;
    if ($utils.isEmptyObject(prevItem)) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: '',
          ansDataTyTpCd: '1',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: value,
        },
      ];
    } else if (prevItem.policyBfNtceItmNo !== value) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        itmDtl => {
          if (
            itmDtl.policyBfNtceItmGrpNo === prevItem.policyBfNtceItmGrpNo &&
            itmDtl.policyBfNtceItmNo === prevItem.policyBfNtceItmNo
          ) {
            return {
              ...itmDtl,
              policyBfNtceItmNo: value,
            };
          }
          return itmDtl;
        },
      );
    }

    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item: items.find(item => item.policyBfNtceItmNo === value) },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  const onChangeNumber = (item, value) => {
    const prevItem = tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
      dtl =>
        dtl.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
        ($utils.isEmptyString(dtl.policyBfNtceItmNo) ||
          radio.find(itm => itm.policyBfNtceItmNo === dtl.policyBfNtceItmNo)),
    );

    let newTbNbsPolicyBfNtceAnsByitmDtlDTO;
    if ($utils.isEmptyObject(prevItem)) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: value,
          ansDataTyTpCd: '1',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: '',
        },
      ];
    } else {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        dtl => {
          if (
            dtl.policyBfNtceItmGrpNo === prevItem.policyBfNtceItmGrpNo &&
            dtl.policyBfNtceItmNo === prevItem.policyBfNtceItmNo
          ) {
            return {
              ...dtl,
              ansContn: value,
            };
          }
          return dtl;
        },
      );
    }

    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  const onChangeText = (item, value) => {
    let newTbNbsPolicyBfNtceAnsByitmDtlDTO;
    if (
      tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
        data =>
          data.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
          data.policyBfNtceItmNo === item.policyBfNtceItmNo,
      )
    ) {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = tbNbsPolicyBfNtceAnsByitmDtlDTO.map(
        data => {
          if (
            data.policyBfNtceItmGrpNo === item.policyBfNtceItmGrpNo &&
            data.policyBfNtceItmNo === item.policyBfNtceItmNo
          ) {
            return {
              ...data,
              ansContn: value,
            };
          }
          return data;
        },
      );
    } else {
      newTbNbsPolicyBfNtceAnsByitmDtlDTO = [
        ...tbNbsPolicyBfNtceAnsByitmDtlDTO,
        {
          ansContn: value,
          ansDataTyTpCd: '2',
          policyBfNtceId: '',
          policyBfNtceItmGrpNo: group.policyBfNtceItmGrpNo,
          policyBfNtceItmNo: item.policyBfNtceItmNo,
        },
      ];
    }
    setTbNbsPolicyBfNtceAnsByitmDtlDTO(newTbNbsPolicyBfNtceAnsByitmDtlDTO);
    onSave(
      value,
      { group, item },
      {
        tbNbsPolicyBfNtceAnsDtlDTO,
        tbNbsPolicyBfNtceAnsByitmDtlDTO: newTbNbsPolicyBfNtceAnsByitmDtlDTO,
      },
    );
  };

  return (
    <table className="medi-history">
      <caption>정보선택</caption>
      <colgroup>
        <col style={{ width: '10rem' }} />
        <col />
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">{title.itmDispContn}</th>
          <td>
            <div className="flex-bx">
              <div className="check-box renew auto">
                <SatRadio
                  name={`table_grp_radio_${group.policyBfNtceItmGrpNo}`}
                  options={radio.map(item => ({
                    label: item.itmDispContn,
                    value: item.policyBfNtceItmNo,
                  }))}
                  disabled={isPreUw}
                  onChange={onChangeRadio}
                  value={
                    tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
                      dtl =>
                        dtl.policyBfNtceItmGrpNo ===
                          group.policyBfNtceItmGrpNo &&
                        radio.find(
                          itm =>
                            itm.policyBfNtceItmNo === dtl.policyBfNtceItmNo,
                        ),
                    )?.policyBfNtceItmNo
                  }
                />
              </div>
              <SatInput
                type="number"
                title={num.itmDispContn}
                disabled={isPreUw}
                maxLength={Number(
                  NOTICE_MAX_LENGTH[num.policyBfNtceInsLenContn],
                )}
                value={
                  tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
                    dtl =>
                      dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo &&
                      radio.find(
                        itm => itm.policyBfNtceItmNo === dtl.policyBfNtceItmNo,
                      ),
                  )?.ansContn
                }
                onChange={value => {
                  onChangeNumber(num, value);
                }}
              />
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">{text.itmDispContn}</th>
          <td>
            <SatInput
              type="text"
              title={text.itmDispContn}
              label={text.itmDispContn}
              disabled={isPreUw}
              maxLength={NOTICE_MAX_LENGTH[text.policyBfNtceInsLenContn]}
              value={
                tbNbsPolicyBfNtceAnsByitmDtlDTO.find(
                  dtl =>
                    dtl.policyBfNtceItmGrpNo === group.policyBfNtceItmGrpNo &&
                    dtl.policyBfNtceItmNo === text.policyBfNtceItmNo,
                )?.ansContn
              }
              onChange={value => {
                onChangeText(text, value);
              }}
            />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

export default TableGroup;
